import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, Ref } from 'vue';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  Modal,
  HeadingDisplay,
  ContentDisplay,
  ListDisplay,
  ButtonContainer,
  ButtonPrimary,
  ButtonSecondary
} from '@warrenbrasil/nebraska-web';
import { Portal } from '@/modules/common/components/Portal';

import { IMarginAllocationV2 } from '@/modules/trade/services/margin-allocation';

interface Props {
  isOpen: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'VariationModal',
  props: {
    isOpen: { type: Boolean }
  },
  setup(__props: any) {



const marginAllocation = inject('marginAllocation') as Ref<IMarginAllocationV2>;

const subtitle = computed(() => {
  return marginAllocation.value.variation.value < 0
    ? 'Prejuízos influenciam na realocação de limites.'
    : '';
});

const variationColor = computed(() => {
  const colorMapper: { [key: string]: NebraskaColors } = {
    positive: NebraskaColors.monetaryPositive,
    negative: NebraskaColors.monetaryNegative,
    primary: NebraskaColors.elementPrimary
  };

  return colorMapper[marginAllocation.value.variation.color];
});

return { __sfc: true,marginAllocation, subtitle, variationColor, Modal, HeadingDisplay, ContentDisplay, ListDisplay, ButtonContainer, ButtonPrimary, ButtonSecondary, Portal }
}

})